module.exports = __webpack_public_path__ + "static/media/EfrainDeLaRosa.401390b6.png";